export const ButtonTypeMap = {
    default: ['default', 'outlined'],
    primary: ['primary', 'solid'],
    dashed: ['default', 'dashed'],
    link: ['primary', 'link'],
    text: ['default', 'text'],
    ghost: ['default', 'outlined'],
};
export function isUnBorderedButtonVariant(variant) {
    return variant === 'text' || variant === 'link';
}
